import { render, staticRenderFns } from "./SuccessEmail.vue?vue&type=template&id=a504e8da&scoped=true"
var script = {}
import style0 from "./SuccessEmail.vue?vue&type=style&index=0&id=a504e8da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a504e8da",
  null
  
)

export default component.exports